import axios from "axios";
import apiURI from "./Api";

export default class AdminService {
  async getAreaManagers(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getareamanager/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getBusinessPartners(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getbusinesspartner/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getSpecialCustomers(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getspecialcustomer/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getSalePromoter(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getsalepromoter/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getSellers(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getseller/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getAllWithdrawRequests(token, adminUsername) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/withdraw/listall/${adminUsername}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getBangoodRequests(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getorders/banggood`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postProcessBangood(token, idOrder) {
    const bodyJson = {
      idorder: idOrder,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/admin/processorder/banggood`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postProcessWithdraw(token, withdrawId, adminUsername) {
    const bodyJson = {
      idwithdraw: withdrawId,
      useradmin: { username: adminUsername },
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/withdraw/process`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getAllOrders(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getorders/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postBlockOrUnblockUser(token, adminUsername, username, block) {
    const bodyJson = {
      admin: { username: adminUsername },
      userToBlockUnblock: { username: username },
      block: block,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/admin/blockunblockuser`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getPaidSubscriptions(token, paymentmethodid) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getpaidsubscriptions/${paymentmethodid}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getPaidSubscriptionsReport(token, dateBegin, dateEnd) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/report/paidsubscriptions?dateBegin=${dateBegin}&dateEnd=${dateEnd}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getPaidSubscriptionsReportPdf(token, dateBegin, dateEnd) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/report/paidsubscriptions/pdf?dateBegin=${dateBegin}&dateEnd=${dateEnd}`,
      headers: { Authorization: "Bearer " + token },
      responseType: "blob",
    });

    return response;
  }

  async getInvoicingStatus(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/invoicing/status`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async enableInvoicing(token) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/admin/invoicing/enable`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async disableInvoicing(token) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/admin/invoicing/disable`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getPaidOrdersReport(token, dateBegin, dateEnd) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/report/paidorders?dateBegin=${dateBegin}&dateEnd=${dateEnd}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getPaidOrdersReportPdf(token, dateBegin, dateEnd) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/report/paidorders/pdf?dateBegin=${dateBegin}&dateEnd=${dateEnd}`,
      headers: { Authorization: "Bearer " + token },
      responseType: "blob",
    });

    return response;
  }

  async getCompletedWithdrawalsReport(token, dateBegin, dateEnd) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/report/completedwithdrawals?dateBegin=${dateBegin}&dateEnd=${dateEnd}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getCompletedWithdrawalsReportPdf(token, dateBegin, dateEnd) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/report/completedwithdrawals/pdf?dateBegin=${dateBegin}&dateEnd=${dateEnd}`,
      headers: { Authorization: "Bearer " + token },
      responseType: "blob",
    });

    return response;
  }

  async getPendingOrders(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getpendingorders`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async confirmOrderBankTransfer(token, admin, idorder) {
    const bodyJson = {
      admin: admin,
      idorder: idorder,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/admin/confirmorderbanktransfer`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getAllSubnets(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/subnet/getAllSubnets`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async createSubnet(token, name, description, username) {
    const bodyJson = {
      name: name,
      description: description,
      username: username,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/subnet/create`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async customizeTheme(token, payload) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/subnet/customizeTheme`,
      data: payload,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  }

  async editSubnet(token, subnetId, name, description) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/subnet/edit`,
      data: { subnetId, name, description },
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  }

  async getCurrentTheme(token, subnetId, username) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/subnet/getCurrentTheme`,
      params: {
        subnetId: subnetId,
        username: username,
      },
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }
}
